

export default {
  name: "NotFound",
  created() {
  },
};
